module.exports = __webpack_public_path__ + "static/media/rbg.e4ab1a91.png";